module.exports = __webpack_public_path__ + "img/syc.6782e83b.png";